import React, { memo } from 'react'
import PropTypes from 'prop-types'
import DOMPurify from 'dompurify'
import { List, ListItem, Typography } from '@mui/material'

const OrderedList = ({ list = [] }) => {
    let listKey = Date.now()
    return (
        <List
            component="ol"
            sx={{
                display: 'grid',
                listStyleType: 'decimal',
                paddingInlineStart: 7,
                wordBreak: 'break-word'
            }}
        >
            {list.map(({ name, desc, order = 0 }, index) => (
                <ListItem
                    key={`${index + listKey}`}
                    tabIndex={0}
                    sx={{
                        color: 'inherit',
                        display: 'list-item',
                        px: 1,
                        py: 0,
                        typography: 'regularBody2',
                        order: order
                    }}
                >
                    <Typography variant="boldBody2" component="span">
                        {name + ': '}
                    </Typography>
                    <Typography
                        variant="regularBody2"
                        component="span"
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(desc, { ADD_ATTR: ['target'] })
                        }}
                    ></Typography>
                </ListItem>
            ))}
        </List>
    )
}

OrderedList.propTypes = {
    list: PropTypes.array
}
export default memo(OrderedList)
